import {useEffect} from 'react'

import {useWsocialVerifiedSession} from '#/lib/wsoc/WsocialVerified.ts'
import {
  useWIDLockByAgeUpgradeControl,
  // useWIDUpgradeControl,
} from '#/components/dialogs/Context.tsx'
import {useGeolocationServiceResponse} from '#/geolocation/service.ts'
import {navigationRef} from '#/Navigation.tsx'

export const useLockScreenByAge = () => {
  const wsocialVerified = useWsocialVerifiedSession()
  const geoResponse = useGeolocationServiceResponse()
  const widUpgradeControl = useWIDLockByAgeUpgradeControl()

  useEffect(() => {
    // if wsocialVerified ===null it means the user has not yet load session
    const shouldBlock =
      geoResponse?.requiredValidation &&
      wsocialVerified !== 'wid' &&
      wsocialVerified === false

    if (!shouldBlock) {
      if (widUpgradeControl.isOpen) widUpgradeControl.close()
      return
    }

    if (shouldBlock && navigationRef.getCurrentRoute()?.name !== 'Onboarding') {
      if (!widUpgradeControl.isOpen) widUpgradeControl.open()
    }

    function openIfNotOnboarding() {
      if (
        geoResponse?.requiredValidation &&
        wsocialVerified !== 'wid' &&
        wsocialVerified === false &&
        navigationRef.getCurrentRoute()?.name !== 'Onboarding' &&
        !widUpgradeControl.isOpen
      ) {
        widUpgradeControl.open()
      }
    }
    return navigationRef.addListener('state', openIfNotOnboarding)
  }, [geoResponse, wsocialVerified, widUpgradeControl])
}
